import React from 'react'
import { Card, CardBody } from 'reactstrap'
import { withRouter } from 'react-router-dom'
import '../../../scss/component/assessments/custom-cards.scss'

class ComplianceCard extends React.Component {
  render () {
    let classes = ''
    if (this.props.hoverColor) {
      classes += ' card-hover '
    }
    if (this.props.isActive) {
      classes = 'compliance-card-active '
    }

    return (
      <Card
        className={`assessment-card ${this.props.clickable ? ' clickable ' : ' '}`}
        id={this.props.id}>
        <CardBody className={classes + this.props.bgColor}
          onClick={() => {
            if (this.props.clickable) {
              this.props.setUpdate(this.props.id, this.props.categoryIndex)
              this.props.changeCategory(this.props.id)
            }
          }}>
          {
            this.props.title
              ? <h3>{this.props.title.substring(0, 73) + (this.props.title.length > 73 ? '...' : '')}</h3>
              : this.props.category
                ? <h3 className='h3-no-title'>
                  {this.props.category.substring(0, 73) + (this.props.category.length > 73 ? '...' : '')}
                </h3>
                : null
          }
          <div className='img-container'>
            <img
              alt={`${this.props.category}-img`}
              src={this.props.img}
            />
            <div className='description'>{this.props.description}</div>
          </div>
        </CardBody>
      </Card>
    )
  }
}

export default withRouter(ComplianceCard)



// WEBPACK FOOTER //
// ./src/components/assessment/components/assessment-card.js